export const SLASH_OPERATOR = 'XXSLASHXX'

export const ONE_LINK_DOMAIN = 'https://indmoney.onelink.me'
export const ONE_LINK_thumb_cta_web = `${ONE_LINK_DOMAIN}/MgHh/xzt9sgz7`
